<template>
  <article id="form">
  
    <textarea class="roster" v-model="roster" @change="trim"></textarea>
    <section class="groupname" @click="name = !name">
      <aside class="checkbox" :class="{ checked : name }"></aside>
      <h3>Ge grupperna ett kickass gruppnamn!</h3>
    </section>
    <section class="leader" @click="leader = !leader">
      <aside class="checkbox" :class="{ checked : leader }"></aside>
      <h3>Slumpa fram en gruppledare / grupp</h3>
    </section>
    <section class="bySize" :class="{ selected : strategy == 'BY_GROUP_SIZE' }" @click="strategy = 'BY_GROUP_SIZE'">Medlemmar / grupp</section>
    <section class="byGroup" :class="{ selected : strategy == 'BY_AMOUNT' }" @click="strategy = 'BY_AMOUNT'">Antal grupper</section>
    <ul class="scale" @click="setSize">
      <li :class="{ selected : size === 2 }">2</li>
      <li :class="{ selected : size === 3 }">3</li>
      <li :class="{ selected : size === 4 }">4</li>
      <li :class="{ selected : size === 5 }">5</li>
      <li :class="{ selected : size === 6 }">6</li>
      <li :class="{ selected : size === 7 }">7</li>
      <li :class="{ selected : size === 8 }">8</li>
      <li :class="{ selected : size === 9 }">9</li>
      <li :class="{ selected : size === 10 }">10</li>
      <li :class="{ selected : size === 11 }">11</li>
      <li :class="{ selected : size === 12 }">12</li>
      <li :class="{ selected : size === 13 }">13</li>
      <li :class="{ selected : size === 14 }">14</li>
    </ul>
    <a href="#" class="btn" @click.prevent="submit">Slump me some groups</a>
  </article>
</template>

<script>
export default {
  name: 'Form',
  data(){
    return {
      name: true,
      leader: false,
      strategy: 'BY_GROUP_SIZE',
      size: 2
    }
  },
  methods: {
    setSize(e) {
      this.size = parseInt(e.target.innerText);
    },
    trim(){
      let list = this.$store.state.roster;
       let arr = list.filter(entry => entry.trim() != '');
        this.$store.commit("updateRoster", arr.join(`\n`))
    },
    submit(){

      if(this.$store.state.roster.length > this.size){   

        const groupSize = (this.strategy == 'BY_GROUP_SIZE') 
        ? this.size
        : this.roster.split('\n').length / this.size

        let settings = {
          name: this.name,
          leader: this.leader,
          type: this.type,
          size: groupSize
        }
        
        this.$store.dispatch('generateGroups', settings);

      } else {
        alert(`Skriv in några fler namn.`);
      }
    }
  },
  computed: {
    roster : {
      get() {
        let list = this.$store.state.roster;
        return list.join(`\n`);
      },
      set(newValue) {
          this.$store.commit("updateRoster", newValue)
      }
    }
  }
}
</script>

<style lang="scss">
@use "sass:color";
@import './../scss/variables';

#form {
  max-width: $formWidth;
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  border-radius: $radius;
  box-shadow: $shadow;
  margin: .5rem;
 
  > * {
    appearance: none;
  }

  .roster {
    grid-column: auto / span 2;
    resize: none;
    border: 0;
    padding: 0 1rem;
    background: $white url('./../assets/line.svg');
    height: (22.5 * $baseline) - 1px;
    border-top-left-radius: $radius;
    border-top-right-radius: $radius;
    line-height: $baseline * 1.5;
    overflow-y: scroll;
  }

  .groupname, .leader {
    grid-column: auto / span 2;
    display: flex;
    align-items: center;
    padding: 0 $baseline;
    height: $baseline * 3;
    font-size: $font-std;
    background: darken($white, 10%);

    &:hover {
      cursor: pointer;
      filter: brightness(.97);

      .checkbox {
        background-image: url('./../assets/check.svg');
        background-size: contain;
        background-repeat: no-repeat;
      }
    } 

    .checkbox {

      &.checked {
        background-image: url('./../assets/check.svg');
        background-size: contain;
        background-repeat: no-repeat;
      }
    }
  }

  .leader {
        background: darken($white, 20%);
  }

  .bySize, .byGroup {
    background: green;
    @include center;
    padding: 0 $baseline-sml;
    height: $baseline * 3;
    position: relative;
    background: darken($white, 30%);
    transition: $transition;

    &:hover {
      cursor: pointer;
      filter: brightness(.97);
    }

    &.selected {
      background: darken($white, 40%);

      &:after, &:after {
        top: 100%;
        left: 50%;
        border: solid transparent;
        content: " ";
        height: 0;
        width: 0;
        position: absolute;
        pointer-events: none;
        border-color: rgba(0, 0, 0, 0);
        border-top-color: darken($white, 40%);
        border-width: 6px;
        margin-left: -6px;
      }
    }
  }

  .scale {
    grid-column: auto / span 2;
    padding: 0 $baseline-sml;
    height: $baseline * 3;
    display: flex;
    justify-content: space-around;
    align-items: center;
    background: darken($white, 60%);

    li {
      width: 20px;
      height: 20px;
      border-radius: 999rem;
      @include center;
      font-size: $font-sml;
      color: $white;
      transition: $transition;

      &:hover {
        cursor: pointer;
        background: rgba($black, .2);
      }

      &.selected {
        background: rgba($black, .8);
      }
    }
  }

  .btn {
    grid-column: auto / span 2;
    height: $baseline * 4;
    @include center;
    font-size: $font-mid;
    text-decoration: none;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    border-bottom-left-radius: $radius;
    border-bottom-right-radius: $radius;
    color: darken($white, 15%);
    background: darken($groupiePrimary, 80%);
    transition: $transition;
    border: none;

    &:hover {
      cursor: pointer;
      color: darken($white, 0%);
    }
  }
}
</style>